// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/folder-open.js';

import { paths } from '../generated/folder-open';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('folder-open', Original, paths);
